import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { MaterialModule } from './submodules/material.module';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { EmailComponent } from './email/email.component';
import { HistoryComponent } from './history/history.component';
import { InvalidSessionComponent } from './invalid-session/invalid-session.component';
import { NgxsModule } from '@ngxs/store';
import { NgxsRouterPluginModule } from '@ngxs/router-plugin';
import { NgxsFormPluginModule } from '@ngxs/form-plugin';
import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
import { AttachmentState } from './state/attachments/attachments.state';
import { EmailState } from './state/email/email.state';
import { HistoryState } from './state/history/history.state';
import { UnsubscribeState } from './state/unsubscribe/unsubscribe.state';
import { ProcessingState } from './state/processing/processing.state';
import { environment } from 'src/environments/environment';
import { WysiwygEditorComponent } from './wysiwyg-editor/wysiwyg-editor.component';
import { ColumnsMenuComponent } from './history/columns-menu/columns-menu.component';
import { AuditDialogComponent } from './history/audit-dialog/audit-dialog.component';
import { AttachmentComponent } from './attachment/attachment.component';
import { ModalComponent } from './modal/modal.component';
import { PreviewEmailDialogComponent } from './preview-email-dialog/preview-email-dialog.component';
import { OpenConfirmDialogComponent } from './history/open-confirm-dialog/open-confirm-dialog.component';
import { UnsubscribeComponent } from './unsubscribe/unsubscribe.component';
import { ClientLogoDirective } from './directives/client-logo.directive';
import { CookieService } from 'ngx-cookie-service';

@NgModule({
  declarations: [
    AppComponent,
    EmailComponent,
    HistoryComponent,
    InvalidSessionComponent,
    WysiwygEditorComponent,
    ColumnsMenuComponent,
    AuditDialogComponent,
    AttachmentComponent,
    ModalComponent,
    PreviewEmailDialogComponent,
    OpenConfirmDialogComponent,
    UnsubscribeComponent,
    ClientLogoDirective
  ],
  entryComponents: [
    AuditDialogComponent,
    AttachmentComponent,
    ModalComponent,
    PreviewEmailDialogComponent,
    OpenConfirmDialogComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    DragDropModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    NgxsModule.forRoot([EmailState, HistoryState, AttachmentState, UnsubscribeState, ProcessingState], {
      developmentMode: !environment.production
    }),
    NgxsLoggerPluginModule.forRoot({
      disabled: environment.production
    }),
    NgxsRouterPluginModule.forRoot(),
    NgxsFormPluginModule.forRoot()
  ],
  providers: [CookieService],
  bootstrap: [AppComponent]
})
export class AppModule { }
